// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scforh-dim-status {
  --dim-ink: #1b2a32;
  --dim-muted: #4a5d66;
  width: 100%;
  text-align: left;
  border-radius: 16px;
  padding: 0.85rem 0.95rem 0.95rem;
  background: linear-gradient(165deg, #f7f3ee 0%, #eef6fb 55%, #f4fbf8 100%);
  border: 1px solid rgba(91, 77, 179, 0.14);
}

.scforh-dim-status--dark {
  --dim-ink: #f4f7f8;
  --dim-muted: rgba(226, 232, 240, 0.8);
  background: linear-gradient(165deg, rgba(91, 77, 179, 0.16) 0%, rgba(29, 138, 120, 0.14) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.scforh-dim-status__eyebrow {
  margin: 0 0 0.25rem;
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5b4db3;
}

.scforh-dim-status--dark .scforh-dim-status__eyebrow {
  color: #c4b5fd;
}

.scforh-dim-status__snapshot {
  margin: 0 0 0.7rem;
  font-size: 0.8rem;
  line-height: 1.45;
  color: var(--dim-muted);
}

.scforh-dim-status__cols {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.1rem;
  margin-bottom: 0.55rem;
}

.scforh-dim-status__label {
  margin: 0 0 0.35rem;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--dim-muted);
}

.scforh-dim-status__label--grow {
  color: #c45c3a;
}

.scforh-dim-status--dark .scforh-dim-status__label--grow {
  color: #fdba74;
}

.scforh-dim-status__col ul {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin: 0;
  padding: 0;
}

.scforh-dim-chip {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.22rem 0.5rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  color: var(--dim-ink);
}

.scforh-dim-status--dark .scforh-dim-chip {
  background: rgba(15, 23, 42, 0.35);
}

.scforh-dim-chip--grow {
  box-shadow: inset 0 0 0 1px rgba(196, 92, 58, 0.35);
}

.scforh-dim-status__hint {
  margin: 0;
  font-size: 0.74rem;
  line-height: 1.4;
  color: var(--dim-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/ScforhDimensionStatus.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,0EAA0E;EAC1E,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,8FAA8F;EAC9F,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".scforh-dim-status {\n  --dim-ink: #1b2a32;\n  --dim-muted: #4a5d66;\n  width: 100%;\n  text-align: left;\n  border-radius: 16px;\n  padding: 0.85rem 0.95rem 0.95rem;\n  background: linear-gradient(165deg, #f7f3ee 0%, #eef6fb 55%, #f4fbf8 100%);\n  border: 1px solid rgba(91, 77, 179, 0.14);\n}\n\n.scforh-dim-status--dark {\n  --dim-ink: #f4f7f8;\n  --dim-muted: rgba(226, 232, 240, 0.8);\n  background: linear-gradient(165deg, rgba(91, 77, 179, 0.16) 0%, rgba(29, 138, 120, 0.14) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.scforh-dim-status__eyebrow {\n  margin: 0 0 0.25rem;\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #5b4db3;\n}\n\n.scforh-dim-status--dark .scforh-dim-status__eyebrow {\n  color: #c4b5fd;\n}\n\n.scforh-dim-status__snapshot {\n  margin: 0 0 0.7rem;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  color: var(--dim-muted);\n}\n\n.scforh-dim-status__cols {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.1rem;\n  margin-bottom: 0.55rem;\n}\n\n.scforh-dim-status__label {\n  margin: 0 0 0.35rem;\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--dim-muted);\n}\n\n.scforh-dim-status__label--grow {\n  color: #c45c3a;\n}\n\n.scforh-dim-status--dark .scforh-dim-status__label--grow {\n  color: #fdba74;\n}\n\n.scforh-dim-status__col ul {\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin: 0;\n  padding: 0;\n}\n\n.scforh-dim-chip {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 0.22rem 0.5rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.7);\n  color: var(--dim-ink);\n}\n\n.scforh-dim-status--dark .scforh-dim-chip {\n  background: rgba(15, 23, 42, 0.35);\n}\n\n.scforh-dim-chip--grow {\n  box-shadow: inset 0 0 0 1px rgba(196, 92, 58, 0.35);\n}\n\n.scforh-dim-status__hint {\n  margin: 0;\n  font-size: 0.74rem;\n  line-height: 1.4;\n  color: var(--dim-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
